import Controller from "./variablePlans.controller";
import template from "./variablePlans.html";

const variablePlans = {
  template,
  controller: Controller,
};

export default variablePlans;



// WEBPACK FOOTER //
// ./src/pages/variablePlans/variablePlans.component.js